import React from 'react'
import Page from './Page.jsx'
import { menuProps } from '../types'
import classnames from 'classnames'
import Tooltip from '../tooltip/Tooltip.jsx'

class Menu extends React.Component {
  static propTypes = menuProps

  menuClick = e => {
    e.preventDefault()
    this.props.updateSidebar(this.props.position, e.currentTarget.value)
  }

  getCurrentContent = currentView => {
    return (
      <>
        <Page
          position={this.props.position}
          shown={this.props.shown}
          currentView={this.props.currentView}
          pageContent={this.props.content.left.sections}
          title={this.props.content.left.title}
          folioSide={this.props.content.left.side}
          highlightedSection={this.props.highlightedSection}
          reverseContent={this.props.reverseContent}
          currentFootnotes={this.props.currentFootnotes}
          updateFootnote={this.props.updateFootnote}
          toggleDrawer={this.props.toggleDrawer}
          showAllFootnotes={this.props.showAllFootnotes}
        />
        <Page
          position={this.props.position}
          shown={this.props.shown}
          currentView={this.props.currentView}
          pageContent={this.props.content.right.sections}
          title={this.props.content.right.title}
          folioSide={this.props.content.right.side}
          highlightedSection={this.props.highlightedSection}
          currentFootnotes={this.props.currentFootnotes}
          updateFootnote={this.props.updateFootnote}
          toggleDrawer={this.props.toggleDrawer}
          showAllFootnotes={this.props.showAllFootnotes}
        />
      </>
    )
  }

  getToggleClass = prop => {
    if (prop) {
      return 'flyout--open'
    } else {
      return ''
    }
  }

  renderTranslation = () => {
    return (
      <li>
        <button
          className={
            this.props.currentView === 'translation' ? 'current' : null
          }
          onClick={this.menuClick}
          type="button"
          value="translation"
        >
          Translation
        </button>
      </li>
    )
  }

  renderTranscription = () => {
    return (
      <li>
        <button
          className={
            this.props.currentView === 'transcription' ? 'current' : null
          }
          onClick={this.menuClick}
          type="button"
          value="transcription"
        >
          Transcription
        </button>
      </li>
    )
  }
  renderMultiMenu = () => {
    return (
      <ul>
        {this.renderTranscription()}
        {this.renderTranslation()}
      </ul>
    )
  }
  renderSingleMenu = currentView => {
    return (
      <React.Fragment>
        <ul>
          {currentView === 'translation'
            ? this.renderTranslation()
            : this.renderTranscription()}
        </ul>
      </React.Fragment>
    )
  }
  renderSwapperSvg() {
    return (
      <svg
        width="18px"
        height="20px"
        viewBox="0 0 18 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <title />
        <desc>Created with Sketch.</desc>
        <g
          id="Symbols"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="ui/swapper" fill="currentColor">
            <g id="Pane-Swapper">
              <g transform="translate(0.538462, 0.000000)">
                <rect
                  id="Rectangle"
                  x="4.92307692"
                  y="4"
                  width="12"
                  height="3.2"
                />
                <polygon
                  id="icon/arrow-left--inactive"
                  transform="translate(3.461538, 5.600000) rotate(270.000000) translate(-3.461538, -5.600000) "
                  points="3.46153846 2.13846154 -2.13846154 9.06153846 9.06153846 9.06153846"
                />
              </g>
              <g transform="translate(8.961538, 14.800000) scale(-1, 1) translate(-8.961538, -14.800000) translate(0.461538, 8.800000)">
                <rect
                  id="Rectangle"
                  x="3.92307692"
                  y="4"
                  width="13"
                  height="3.2"
                />
                <polygon
                  id="icon/arrow-left--inactive"
                  transform="translate(3.461538, 5.600000) rotate(270.000000) translate(-3.461538, -5.600000) "
                  points="3.46153846 2.13846154 -2.13846154 9.06153846 9.06153846 9.06153846"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
  renderReverse() {
    if (this.props.reverseContent) {
      const reverseContentClass = classnames('flyout__content-switch', {
        'flyout__content-switch--active': this.props.panesFlipped === true,
      })
      return (
        <Tooltip tooltipText="Swap content panes">
          <button
            className={reverseContentClass}
            onClick={() => this.props.reverseContent()}
            type="button"
          >
            {this.renderSwapperSvg()}
            <span className="visually-hidden">Switch Panel Content</span>
          </button>
        </Tooltip>
      )
    } else {
      return ''
    }
  }
  render() {
    return (
      <div
        className={
          'flyout__side ' + 'flyout__side--' + this.props.position + ' '
        }
      >
        <div
          aria-hidden={this.props.toggled ? false : true}
          className="flyout__bar"
        >
          <div className="flyout__menu js-flyout__menu">
            {this.props.position === 'left' && this.props.shown === 'one'
              ? this.renderMultiMenu()
              : this.renderSingleMenu(this.props.currentView)}

            {this.props.position === 'left' && this.props.shown === 'both'
              ? this.renderReverse()
              : null}
          </div>
          <div
            className={
              'flyout__content js-flyout__content--' + this.props.currentView
            }
          >
            {this.getCurrentContent(this.props.currentView)}
          </div>
        </div>
      </div>
    )
  }
}
export default Menu
